import {
  getProjectType,
  setProjectType
} from '@/services/organization'

export default {
  namespaced: true,
  state: {
    loading: false,
    orgProjectData: {}
  },
  mutations: {
    setLoading (state, data) {
      state.loading = data
    },
    setOrgProjectData (state, data) {
      state.orgProjectData = data
    }
  },
  actions: {
    async getProjectType ({ commit }, params) {
      commit('setLoading', true)
      const chain = await getProjectType()
      chain
        .params(params)
        .onSuccess(raw => {
          commit('setOrgProjectData', raw)
        })
        .onNetComplete(() => {
          commit('setLoading', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    async setProjectType ({ commit }, params) {
      const chain = await setProjectType()
      chain
        .params(params)
        .config({
          error100: false
        })
        .fetch()
      return chain
    }
  }
}
